import { useEffect, useRef } from 'react';
import { getIsLoadingItemsA11yStatus, getItemClearedA11yStatus, getItemSelectedA11yStatus, getNoResultA11yStatus, getResultCountChangedA11yStatus, } from './translations';
import debounce from 'lodash.debounce';
var getStatusDiv = function () {
    var id = 'a11y-status-message';
    var statusDiv = window.document.getElementById(id);
    if (statusDiv) {
        return statusDiv;
    }
    statusDiv = window.document.createElement('div');
    statusDiv.setAttribute('id', id);
    statusDiv.setAttribute('role', 'status');
    statusDiv.setAttribute('aria-live', 'polite');
    statusDiv.setAttribute('aria-relevant', 'additions text');
    Object.assign(statusDiv.style, {
        border: '0',
        clip: 'rect(0 0 0 0)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        width: '1px',
    });
    window.document.body.appendChild(statusDiv);
    return statusDiv;
};
var cleanupStatus = debounce(function () {
    getStatusDiv().textContent = '';
}, 500);
var setStatus = function (status) {
    var div = getStatusDiv();
    if (!status) {
        return;
    }
    div.textContent = status;
    cleanupStatus();
};
var updateA11yStatus = debounce(function (getA11yMessage) {
    setStatus(getA11yMessage());
}, 200);
var getItemSelectedMessage = function (_a) {
    var selectedValue = _a.selectedValue, locale = _a.locale;
    if (!selectedValue) {
        return getItemClearedA11yStatus(locale);
    }
    return getItemSelectedA11yStatus(locale, selectedValue);
};
var getStateChangeMessage = function (_a) {
    var isExpanded = _a.isExpanded, resultCount = _a.resultCount, locale = _a.locale;
    if (!isExpanded) {
        return '';
    }
    if (!resultCount) {
        return getNoResultA11yStatus(locale);
    }
    return getResultCountChangedA11yStatus(locale, resultCount);
};
var getIsLoadingItemsMessage = function (locale) {
    return getIsLoadingItemsA11yStatus(locale);
};
export var useSetAllyMessageItemSelection = function (_a) {
    var hasFocus = _a.hasFocus, isExpanded = _a.isExpanded, isLoading = _a.isLoading, locale = _a.locale, resultCount = _a.resultCount, selectedValue = _a.selectedValue;
    var isInitialMount = useRef(true);
    var prevSelectedValue = useRef();
    useEffect(function () {
        if (isLoading && hasFocus) {
            updateA11yStatus(function () {
                return getIsLoadingItemsMessage(locale);
            });
            return;
        }
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }
        var selectedItemHasChanged = selectedValue !== prevSelectedValue.current;
        if (selectedItemHasChanged) {
            prevSelectedValue.current = selectedValue;
            updateA11yStatus(function () {
                return getItemSelectedMessage({ selectedValue: selectedValue, locale: locale });
            });
        }
        else {
            updateA11yStatus(function () {
                return getStateChangeMessage({
                    isExpanded: isExpanded,
                    resultCount: resultCount,
                    locale: locale,
                });
            });
        }
        return function () {
            // Cancel debounce before component unmounts
            updateA11yStatus.cancel();
            cleanupStatus.cancel();
        };
    }, [selectedValue, locale, isExpanded, resultCount, hasFocus, isLoading]);
};
export var setArrowAllyMessage = function (highlightedValue, dropdownAttributes) {
    var highlightedValueString = dropdownAttributes
        .map(function (attr) { return highlightedValue[attr]; })
        .join(' ');
    getStatusDiv().textContent = "".concat(highlightedValueString);
};
